"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeGetRoutePath(path) {
    return (function () { return '/' + path.map(function (_a) {
        var isParam = _a.isParam, value = _a.value;
        return "" + (isParam ? ':' : '') + value;
    }).join('/'); });
}
exports.default = makeGetRoutePath;
